module.exports = __webpack_public_path__ + "static/img/数字沙盘.2fcdbf69.png";